var creditCardMasks = {
    'amex': {
        'input': '9999-999999-99999',
        'mask': '####-######-99999'
    },
    'dinersclub': {
        'input': '9999-999999-9999',
        'mask': '####-######-9999'
    },
    'discover': {
        'input': '9999-9999-9999-9999',
        'mask': '####-####-####-9999'
    },
    'mastercard': {
        'input': '9999-9999-9999-9999',
        'mask': '####-####-####-9999'
    },
    'visa': {
        'input': '9999-9999-9999-9999',
        'mask': '####-####-####-9999'
    }
};

export default {
    getInputValidatorForIssuerCode: function getInputValidatorForIssuerCode(code) {
        return creditCardMasks[code].input;
    },

    getInputMaskForIssuerCode: function getInputMaskForIssuerCode(code) {
        return creditCardMasks[code].mask;
    },

    getInputLength: function getInputLength(code) {
        return creditCardMasks[code].input.replace(/-/g, '').length;
    },

    getMaskedValue: function getMaskedValue(number, issuer) {
        var mask = creditCardMasks[issuer].mask;

        var valueMasked = '';

        if (number.length && number.length === mask.replace(/-/g, '').length) {
            var numberPosition = 0;
            angular.forEach(mask.split(''), function (chr, i) {
                if (mask[i] === '#') {
                    valueMasked += '#';
                    numberPosition++;
                } else if (mask[i] === '-') {
                    valueMasked += '-';
                } else {
                    valueMasked += number[numberPosition];
                    numberPosition++;
                }
            });
        }

        return valueMasked;
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/paymentdetails/CreditCardUtil.js
// module id = 1055
// module chunks = 0